/**
 * Retrieves a value from a config object using dot notation.
 *
 * @param {Object} obj - The config object.
 * @param {string} key - The key to retrieve (supports dot notation).
 * @returns {any} - The value of the key.
 */
export function getPathValue(obj: Record<string, any>, key: string): any {
  try {
    return key
      .split('.')
      .reduce((current: Record<string, any>, part: string) => {
        if (!Object.prototype.hasOwnProperty.call(current, part)) {
          throw Error();
        }
        return current[part];
      }, obj);
  } catch {
    console.warn(`Property ${key} does not exist in the object`);
    return undefined;
  }
}
